import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/index/s2.webp")